export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manag.4148680e.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};